import { useLocalSearchParams } from 'expo-router'

import { INTENTION_TYPE } from '@/src/features/intention/models/Intention.enums'
import { IntentionPrayScreen } from '@/src/features/intention/ui/screens/IntentionPrayScreen'
import { routeToPath } from '@/src/general/constants/routes'
import { useBackHandlePress } from '@/src/general/hooks/useBackHandlePress'
import { TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'
import { parseIdDash } from '@/src/general/utils/parseIdDash'
import { useRoutes } from '@/src/general/utils/routes'

const PublicationRewardPrayRouterPage = () => {
  const { intentionIdToken, id: publicationId } = useLocalSearchParams<{ intentionIdToken: TIdDashSlug; id: string }>()

  const { routes } = useRoutes()
  const fallbackRoute = routes.publicationByIdReward(Number(publicationId), { source: TRACKING_SOURCE.UNDEFINED })
  const { handleBackPress } = useBackHandlePress(fallbackRoute)

  if (!intentionIdToken) {
    return null
  }

  const [intentionId, shareToken] = parseIdDash(intentionIdToken)

  return (
    <IntentionPrayScreen
      intentionId={intentionId}
      shareToken={shareToken}
      type={INTENTION_TYPE.INTENTION}
      source={TRACKING_SOURCE.INTENTION_POSTPUBCTA}
      redirect={routeToPath(fallbackRoute)}
      skipReward
      onClose={handleBackPress}
    />
  )
}

export default PublicationRewardPrayRouterPage
